<template>
   <div class="home_say_content">
    <div class="home_say_left home_say_click" @click="clickLeft" @mouseover="slideOver" @mouseout="slideOut">
      <img src="/static/imgs/arrow_left.svg" alt="" />
      </div>
      <div class="home_say_content_line" v-if='count==2'>
        <div id="slide" class="home_say_content_item" v-for="(item, index) in sayList" :key="index"
          :style="{transform: `translateX(${-sayIndex * 610 + 10 + 'px'})`}" @mouseenter="slideOver"
          @mouseleave="slideOut">
          <div v-if="cater==1">
          <div class="home_say_content_top">
            <img :src="item.icon" alt="" />
            <span class="home_say_content_top_name">{{item.name}}</span>
            <em></em>
            <span class="home_say_content_top_country">{{item.country}}</span>
          </div>
          <div class="home_say_content_text">{{item.content}}</div>
          </div>
          <div v-else>
            <div class="home_say_content_top2"><img :src="item.icon" :alt=item.name /></div>
            <p class="home_say_content_top_name2">{{item.name}}</p>
          <div class="home_say_content_text2">{{item.content}}</div>
          </div>
        </div>
      </div>
      <div class="home_say_content_line home_say_content_line2" v-if='count==3'>
        <div id="slide" class="home_say_content_item2" v-for="(item, index) in sayList" :key="index"
          :style="{transform: `translateX(${-sayIndex * 406 + 'px'})`}" @mouseenter="slideOver"
          @mouseleave="slideOut">
            <div class="home_say_content_head">
              <img :src="item.icon" :alt=item.name />
              <span>{{item.name}}</span>
            </div>
            <div class="home_say_content_star">
              <img src="/static/imgs/store37.svg" alt="">
              <img src="/static/imgs/store37.svg" alt="">
              <img src="/static/imgs/store37.svg" alt="">
              <img src="/static/imgs/store37.svg" alt="">
              <img src="/static/imgs/store37.svg" alt="">
            </div>
            <p class="home_say_content_center">{{item.content}}</p>
        </div>
      </div>
      <div class="home_say_right home_say_click" @click="clickRight" @mouseover="slideOver" @mouseout="slideOut">
        <img src="/static/imgs/arrow_right.svg" alt="" />
      </div>
  </div>
</template>

<script>
export default {
  name: 'display',
  props: ['sayList','name','cater','count'],
  data () {
    return {
      isMobileHome:false,
      slideshow: undefined,
      handleScrollFlag: true,
      time: undefined,
      changeSayTimer: undefined,
      sayIndex:0,
      screenWidth: window.innerWidth,
      lastdata:''
    }
  },
  methods: {
    enlargeSayList() { 
      if (this.screenWidth > 767) {
        if(this.count==3){
          this.sayList.unshift(this.sayList[this.sayList.length - 1]);
          this.sayList.unshift(this.sayList[this.sayList.length - 2]);
          this.sayList[this.sayList.length] = this.sayList[2];
          this.sayIndex = 2;
          this.lastdata=this.sayList.length - 3
        }else{
          this.sayList.unshift(this.sayList[this.sayList.length - 1]);
          this.sayList[this.sayList.length] = this.sayList[1];
          this.sayIndex = 1;
          this.lastdata=this.sayList.length - 2
        }
      }
    },
    tabScroll() {
      window.addEventListener("scroll", this.handleScrollHome);
    },
    handleScrollHome() {
      if (
        this.handleScrollFlag &&
        this.screenWidth > 767 &&
        document.querySelector(this.name)
      ) {
        var exp_height = document
          .querySelector(this.name)
          .getBoundingClientRect().top;
        clearInterval(this.slideshow);
        if (exp_height < 450 && exp_height > -300) {
          this.handleScrollFlag = false;
          this.slideshow = setInterval(this.clickRight, 2000);
        }
      }
    },
    clickRight() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == this.lastdata) {
          for (let i = 0; i < this.sayList.length; i++) {       
            document.querySelector(`.home_say_content_item${this.count==3?'2':''}`).className =
              `home_say_content_item_no_transition${this.count==3?'2':''}`;
          }
          this.sayIndex = 0;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex++;
        }
      }
    },
    clickLeft() {
      let date1 = new Date().getTime();
      if (!this.time || this.time < date1 - 500) {
        this.time = date1;
        if (this.sayIndex == 0) {
          for (let i = 0; i < this.sayList.length; i++) {
            document.querySelector(`.home_say_content_item${this.count==3?'2':''}`).className =
              `home_say_content_item_no_transition${this.count==3?'2':''}`;
          }
          this.sayIndex = this.lastdata;
          this.changeSayTimer = setTimeout(this.changeSeamless, 500);
        } else {
          this.sayIndex--;
        }
      }
    },
    changeSeamless() {
      clearTimeout(this.changeSayTimer);
      if (this.sayIndex == 0) {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
            `.home_say_content_item_no_transition${this.count==3?'2':''}`
          ).className = `home_say_content_item${this.count==3?'2':''}`;
        }
        this.sayIndex++;
      } else {
        for (let i = 0; i < this.sayList.length; i++) {
          document.querySelector(
           `.home_say_content_item_no_transition${this.count==3?'2':''}`
          ).className = `home_say_content_item${this.count==3?'2':''}`;
        }
        this.sayIndex--;
      }
    },
    slideOver () {
      if (this.screenWidth > 767) {
        clearInterval(this.slideshow)
      }
    },
    slideOut () {
      if (this.screenWidth > 767) {
        // this.clickRight()
        this.slideshow = setInterval(this.clickRight, 2000);
      }
    },
  },
  created () {
    this.enlargeSayList()
    if (document.body.offsetWidth > 767) {
      this.isMobileHome = false
    } else {
      this.isMobileHome = true
    }
  },
  mounted () {
    if (this.isMobileHome) {
      // this.keyRoll();
    } else {
      this.tabScroll();
    }
  },
  deactivated() {
    if (this.isMobileHome) {
      // window.removeEventListener('scroll', this.keyRollChange, true)
    } else {
      window.removeEventListener("scroll", this.handleScrollHome);
      if (this.slideshow) {
        window.clearInterval(this.slideshow);
      }
    }
  },
}
</script>

<style scoped>
.home_say_content {
  position: relative;
}
.home_say_content_line {
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  padding: 18px 0 18px 0;
}
.home_say_content_line2{
  padding:0;
}
.home_say_left,
.home_say_right {
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  cursor: not-allowed;
}
.home_say_left {
  left: -58px;
}
.home_say_right {
  right: -58px;
}
.home_say_click:hover {
  background: #c9cdd7;
  cursor: pointer;
}
.home_say_content_item {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
  transition: all 0.8s;
}
.home_say_content_item + .home_say_content_item {
  margin-left: 20px;
}
.home_say_content_item_no_transition {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
}
.home_say_content_item_no_transition + .home_say_content_item_no_transition {
  margin-left: 20px;
}
.home_say_content_top {
  display: flex;
  align-items: center;
}
.home_say_content_top2 {
  display: flex;
  justify-content: center;
}
.home_say_content_top img {
  width: 48px;
  height: 48px;
}
.home_say_content_top2 img {
  width: 60px;
  height: 60px;
}
.home_say_content_top em {
  width: 1px;
  height: 16px;
  background: #8d919b;
}
.home_say_content_top_name {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin: 0 15px 0 28px;
}
.home_say_content_top_name2 {
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 700;
  margin: 11px 0 21px 0;
}
.home_say_content_top_country {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 28px;
  margin-left: 20px;
}
.home_say_content_text {
  margin: 21px 0 0 8px;
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
}
.home_say_content_text2 {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #8D919B;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
  font-weight: 400;
}
.home_say_content_item2{
  flex: none;
  width: 386px;
  background: #FFFFFF;
  box-shadow: 0px 8px 24px 0px rgba(139,145,160,0.1);
  border-radius: 8px;
  padding: 30px 20px 50px 20px;
  transition: all 0.8s;
}
.home_say_content_item2 + .home_say_content_item2 {
  margin-left: 20px;
}
.home_say_content_item_no_transition2 {
  flex: none;
  width: 386px;
  background: #fff;
  padding: 30px 20px 50px 20px;
  box-shadow: 0px 8px 24px 0px rgba(139,145,160,0.1);
  border-radius: 8px;
}
.home_say_content_item_no_transition2 + .home_say_content_item_no_transition2 {
  margin-left: 20px;
}
.home_say_content_head{
  display: flex;
  align-items: center;
}
.home_say_content_head img{
  width: 48px;
  height: 48px;
  margin-right: 20px;
}
.home_say_content_head span{
  font-family: Helvetica-Bold;
  font-size: 20px;
  color: #222536;
  text-align: justify;
  line-height: 28px;
  font-weight: 700;
}
.home_say_content_star{
  display: flex;
  align-items: center;
  margin: 23px 0 15px 0;
}
.home_say_content_star img{
  margin-right: 4.5px;
}
.home_say_content_center{
  font-family: Helvetica;
  font-size: 16px;
  color: #8D919B;
  text-align: justify;
  line-height: 24px;
  font-weight: 400;
}
@media (max-width: 767px){
  /* home */
  .home_say_content_top img {
    width: 0.72rem;
    height: 0.72rem;
  }
  .home_say_content_top em {
    width: 0.02rem;
    height: 0.24rem;
    background: #8d919b;
  }
  .home_say_content_line {
    overflow: auto;
  }
  .home_say_left,
  .home_say_right {
    display: none;
  }
  .home_say_content_item {
    width: 5.75rem;
    height: 5.34rem;
    padding: .4rem .48rem .48rem .7rem;
    box-shadow: 0px .12rem .36rem 0px rgba(139, 145, 160, 0.15);
    border-radius: .12rem;
  }
  .home_say_content_item + .home_say_content_item {
    margin-left: .3rem;
  }
  .home_say_content_top2 img {
    width: .72rem;
    height: .72rem;
  }
  .home_say_content_top_name {
    margin: 0 0.24rem 0 0.42rem;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
  }
  .home_say_content_top_name2 {
    font-size: .28rem;
    margin: .33rem 0 .245rem 0;
  }
  .home_say_content_top_country {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.42rem;
    margin-left: 0.24rem;
  }
 .home_say_content_text {
    margin: 0.31rem 0 0;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.36rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;
    overflow: hidden;
  }
  .home_say_content_text2 {
    width: 4.79rem;
    height: 2.66rem;
    font-size: .24rem;
    line-height: .38rem;
    text-align: justify;
  }
  .home_say_content_item2{
    width: 3.86rem;
    box-shadow: 0px .06rem .24rem 0px rgba(139,145,160,0.1);
    border-radius: .08rem;
    padding: .3rem .2rem .5rem .2rem;
  }
  .home_say_content_item2 + .home_say_content_item2 {
    margin-left: .2rem;
  }
  .home_say_content_item_no_transition2 {
    width: 3.86rem;
    box-shadow: 0px .06rem .24rem 0px rgba(139,145,160,0.1);
    border-radius: .08rem;
    padding: .3rem .2rem .5rem .2rem;
  }
  .home_say_content_item_no_transition2 + .home_say_content_item_no_transition2 {
    margin-left: .2rem;
  }

  .home_say_content_head img{
    width: .48rem;
    height: .48rem;
    margin-right: .2rem;
  }
  .home_say_content_head span{
    font-size: .2rem;
    line-height: .28rem;
  }
  .home_say_content_star{
    margin: .23rem 0 .15rem 0;
  }
  .home_say_content_star img{
    margin-right: .045rem;
  }
  .home_say_content_center{
    font-size: .16rem;
    line-height: .24rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/display.vue